/**
 * Generated by orval v8.8.0 🍺
 * Do not edit manually.
 * PatientPortal
 * OpenAPI spec version: v1
 */
import type {
  AddressDTO,
  AppointmentConfirmationRequestDTO,
  ApproveLoginResponseDTO,
  AssociateInsuranceCardRequestDTO,
  CheckPasswordlessStatusDTO,
  ConsentFormsCommuniqueDTO,
  DeleteApiPatientPortalChartsDeleteInsuranceParams,
  DeliveredPatientStatementDTO,
  FormFieldAssignee,
  FormWorkflowCompletionRequestDTO,
  FormWorkflowWithTransitionSuccessMessageResponseDTO,
  FormsRenderingMetadataResponseDTO,
  GetApiAddressGetGeoCodeByAddressParams,
  GetApiPatientPortalInsuranceSearchParams,
  GetApiPatientPortalMultiMediaGetMultiMediaByIdParams,
  GetApiPatientPortalOrganizationGetOrgServiceFacilitiesParams,
  GetApiPatientPortalProviderSearchExternalProviderParams,
  GetApiRTMGetCheckInQuestionsParams,
  GetApiRTMGetEnrollmentInfoParams,
  GetApiRTMGetStatusByPatientIdParams,
  GetApiSettingsGePatientHistoryOptionsParams,
  GetApiTempoGetTempoStatusByPatientIdParams,
  GetTokenRequestDTO,
  GetTokenResponseDTO,
  InsuranceAttachmentDTO,
  InsuranceDTO,
  InsuranceSettingsDTO,
  ModMedOrganizationDTO,
  ModMedTempoSendCommuniqueRequestDTO,
  ModMedUATAppointmentDTO,
  ModMedUATAppointmentsRequestDTO,
  ModMedUATSendCallRequestDTO,
  ModMedUATSendCallResponseDTO,
  ModifyAppointmentStatusResponseDTO,
  MultiMediaRequestDTO,
  MultiMediaResponseDTO,
  NPISearchResponseDTO,
  None,
  OrganizationDTO,
  PCCProgram,
  PatientDTO,
  PatientLoginRequestDTO,
  PatientMultiMediaResponseDTO,
  PatientOrgMappingDTO,
  PatientPCCItemsDTO,
  PatientPaymentDetailsDTO,
  PatientPortalLoginOptionsDTO,
  PatientPortalMultiMediaUploadDTO,
  PatientPortalMultimediaRequestDTO,
  PatientStatementAppointmentSnapshotDTO,
  PatientStatementForPaymentResponseDTO,
  PatientTempoStatus,
  PatientVisitDTO,
  PayerEntryDTO,
  PostApiPatientPortalAuthApproveLoginParams,
  PostApiPatientPortalAuthLogoutParams,
  PostApiRTMCompleteEnrollmentParams,
  PostApiTempoSendDayOneCommuniqueParams,
  PostApiTempoSendDayTwoCommuniqueParams,
  RTMAnswers,
  RTMEnrollmentInfoResponse,
  RTMPatientStatusResponseDTO,
  RTMQuestionsResponse,
  RefreshTokenRequestDTO,
  SendMagicLinkRequestDTO,
  SendMagicLinkResponseDTO,
  SendOTPResponseDTO,
  ServiceFacilityDTOListDTO,
  SettingsDTO,
  StringPaginatedResponseDTO,
  SyncInsuranceAttachmentsRequestDTO,
  TempoAnswers,
  TempoQuestionsResponse,
  TempoSubmitAnswerResponseDto,
  UploadAndAssociateInsuranceCardRequestDTO,
  UpsertInsuranceRequestDTO,
  VerifyOTPRequestDTO,
  VerifyOTPResponseDTO
} from './dtos';

import { sendRequest } from './utils/httpClient';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getApiAddressGetGeoCodeByAddress = (
    params?: GetApiAddressGetGeoCodeByAddressParams,
 options?: SecondParameter<typeof sendRequest<AddressDTO>>,) => {
      return sendRequest<AddressDTO>(
      {url: `/api/Address/GetGeoCodeByAddress`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientPortalAppointmentUpcoming = (

 options?: SecondParameter<typeof sendRequest<PatientVisitDTO[]>>,) => {
      return sendRequest<PatientVisitDTO[]>(
      {url: `/api/PatientPortal/Appointment/Upcoming`, method: 'GET'
    },
      options);
    }

export const getApiPatientPortalAppointmentHistorical = (

 options?: SecondParameter<typeof sendRequest<PatientVisitDTO[]>>,) => {
      return sendRequest<PatientVisitDTO[]>(
      {url: `/api/PatientPortal/Appointment/Historical`, method: 'GET'
    },
      options);
    }

export const postApiPatientPortalAppointmentUpdateStatus = (
    appointmentConfirmationRequestDTO: AppointmentConfirmationRequestDTO,
 options?: SecondParameter<typeof sendRequest<ModifyAppointmentStatusResponseDTO>>,) => {
      return sendRequest<ModifyAppointmentStatusResponseDTO>(
      {url: `/api/PatientPortal/Appointment/UpdateStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appointmentConfirmationRequestDTO
    },
      options);
    }

export const getApiPatientPortalAuthGetLoginOptions = (

 options?: SecondParameter<typeof sendRequest<PatientPortalLoginOptionsDTO>>,) => {
      return sendRequest<PatientPortalLoginOptionsDTO>(
      {url: `/api/PatientPortal/Auth/GetLoginOptions`, method: 'GET'
    },
      options);
    }

export const postApiPatientPortalAuthSendOTP = (
    patientLoginRequestDTO: PatientLoginRequestDTO,
 options?: SecondParameter<typeof sendRequest<SendOTPResponseDTO>>,) => {
      return sendRequest<SendOTPResponseDTO>(
      {url: `/api/PatientPortal/Auth/SendOTP`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientLoginRequestDTO
    },
      options);
    }

export const postApiPatientPortalAuthVerifyOTP = (
    verifyOTPRequestDTO: VerifyOTPRequestDTO,
 options?: SecondParameter<typeof sendRequest<VerifyOTPResponseDTO>>,) => {
      return sendRequest<VerifyOTPResponseDTO>(
      {url: `/api/PatientPortal/Auth/VerifyOTP`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOTPRequestDTO
    },
      options);
    }

export const postApiPatientPortalAuthSendMagicLink = (
    sendMagicLinkRequestDTO: SendMagicLinkRequestDTO,
 options?: SecondParameter<typeof sendRequest<SendMagicLinkResponseDTO>>,) => {
      return sendRequest<SendMagicLinkResponseDTO>(
      {url: `/api/PatientPortal/Auth/SendMagicLink`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendMagicLinkRequestDTO
    },
      options);
    }

export const postApiPatientPortalAuthSendOTPTestEmail = (
    postApiPatientPortalAuthSendOTPTestEmailBody: string,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/PatientPortal/Auth/SendOTPTestEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiPatientPortalAuthSendOTPTestEmailBody
    },
      options);
    }

export const postApiPatientPortalAuthSendMagicLinkTestEmail = (
    postApiPatientPortalAuthSendMagicLinkTestEmailBody: string,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/PatientPortal/Auth/SendMagicLinkTestEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiPatientPortalAuthSendMagicLinkTestEmailBody
    },
      options);
    }

export const postApiPatientPortalAuthApproveLogin = (
    params?: PostApiPatientPortalAuthApproveLoginParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PatientPortal/Auth/ApproveLogin`, method: 'POST',
        params
    },
      options);
    }

export const postApiPatientPortalAuthCheckPasswordlessStatus = (
    checkPasswordlessStatusDTO: CheckPasswordlessStatusDTO,
 options?: SecondParameter<typeof sendRequest<ApproveLoginResponseDTO>>,) => {
      return sendRequest<ApproveLoginResponseDTO>(
      {url: `/api/PatientPortal/Auth/CheckPasswordlessStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkPasswordlessStatusDTO
    },
      options);
    }

export const postApiPatientPortalAuthGetToken = (
    getTokenRequestDTO: GetTokenRequestDTO,
 options?: SecondParameter<typeof sendRequest<GetTokenResponseDTO>>,) => {
      return sendRequest<GetTokenResponseDTO>(
      {url: `/api/PatientPortal/Auth/GetToken`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getTokenRequestDTO
    },
      options);
    }

export const postApiPatientPortalAuthRefreshToken = (
    refreshTokenRequestDTO: RefreshTokenRequestDTO,
 options?: SecondParameter<typeof sendRequest<GetTokenResponseDTO>>,) => {
      return sendRequest<GetTokenResponseDTO>(
      {url: `/api/PatientPortal/Auth/RefreshToken`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshTokenRequestDTO
    },
      options);
    }

export const postApiPatientPortalAuthLogout = (
    params?: PostApiPatientPortalAuthLogoutParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PatientPortal/Auth/Logout`, method: 'POST',
        params
    },
      options);
    }

export const getApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogId = (
    patientStatementDeliveryLogId: number,
 options?: SecondParameter<typeof sendRequest<PatientStatementAppointmentSnapshotDTO[]>>,) => {
      return sendRequest<PatientStatementAppointmentSnapshotDTO[]>(
      {url: `/api/Billing/GetPatientStatementEncounterSnapshots/${patientStatementDeliveryLogId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientPortalBillingGetPaymentDetails = (

 options?: SecondParameter<typeof sendRequest<PatientPaymentDetailsDTO>>,) => {
      return sendRequest<PatientPaymentDetailsDTO>(
      {url: `/api/PatientPortal/Billing/GetPaymentDetails`, method: 'GET'
    },
      options);
    }

export const postApiPatientPortalBillingGenerateStatementForPatientPayment = (

 options?: SecondParameter<typeof sendRequest<PatientStatementForPaymentResponseDTO>>,) => {
      return sendRequest<PatientStatementForPaymentResponseDTO>(
      {url: `/api/PatientPortal/Billing/GenerateStatementForPatientPayment`, method: 'POST'
    },
      options);
    }

export const getApiPatientPortalBillingGetPatientStatements = (

 options?: SecondParameter<typeof sendRequest<DeliveredPatientStatementDTO[]>>,) => {
      return sendRequest<DeliveredPatientStatementDTO[]>(
      {url: `/api/PatientPortal/Billing/GetPatientStatements`, method: 'GET'
    },
      options);
    }

export const getApiPatientPortalChartsGet = (

 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/PatientPortal/Charts/Get`, method: 'GET'
    },
      options);
    }

export const patchApiPatientPortalChartsUpdate = (
    patientDTO: PatientDTO,
 options?: SecondParameter<typeof sendRequest<PatientDTO>>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/PatientPortal/Charts/Update`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patientDTO
    },
      options);
    }

export const postApiPatientPortalChartsAddInsurance = (
    upsertInsuranceRequestDTO: UpsertInsuranceRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceDTO>>,) => {
      return sendRequest<InsuranceDTO>(
      {url: `/api/PatientPortal/Charts/AddInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertInsuranceRequestDTO
    },
      options);
    }

export const putApiPatientPortalChartsUpdateInsurance = (
    upsertInsuranceRequestDTO: UpsertInsuranceRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceDTO>>,) => {
      return sendRequest<InsuranceDTO>(
      {url: `/api/PatientPortal/Charts/UpdateInsurance`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertInsuranceRequestDTO
    },
      options);
    }

export const deleteApiPatientPortalChartsDeleteInsurance = (
    params?: DeleteApiPatientPortalChartsDeleteInsuranceParams,
 options?: SecondParameter<typeof sendRequest<void>>,) => {
      return sendRequest<void>(
      {url: `/api/PatientPortal/Charts/DeleteInsurance`, method: 'DELETE',
        params
    },
      options);
    }

export const getApiCommunicationGetConsentFormCommuniqueByTokenToken = (
    token: string,
 options?: SecondParameter<typeof sendRequest<ConsentFormsCommuniqueDTO>>,) => {
      return sendRequest<ConsentFormsCommuniqueDTO>(
      {url: `/api/Communication/GetConsentFormCommuniqueByToken/${token}`, method: 'GET'
    },
      options);
    }

export const getApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssignee = (
    formWorkflowId: number,
    assignee: FormFieldAssignee,
 options?: SecondParameter<typeof sendRequest<FormsRenderingMetadataResponseDTO>>,) => {
      return sendRequest<FormsRenderingMetadataResponseDTO>(
      {url: `/api/FormWorkflow/GetRenderingMetadata/${formWorkflowId}/${assignee}`, method: 'GET'
    },
      options);
    }

export const postApiFormWorkflowCompletePatientStep = (
    formWorkflowCompletionRequestDTO: FormWorkflowCompletionRequestDTO,
 options?: SecondParameter<typeof sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>>,) => {
      return sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>(
      {url: `/api/FormWorkflow/CompletePatientStep`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowCompletionRequestDTO
    },
      options);
    }

export const getApiFormWorkflowGetWorkflowPdfsFormWorkflowId = (
    formWorkflowId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/FormWorkflow/GetWorkflowPdfs/${formWorkflowId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientPortalInsuranceSearch = (
    params?: GetApiPatientPortalInsuranceSearchParams,
 options?: SecondParameter<typeof sendRequest<PayerEntryDTO[]>>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/PatientPortal/Insurance/Search`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientPortalInsuranceGetFavorites = (

 options?: SecondParameter<typeof sendRequest<PayerEntryDTO[]>>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/PatientPortal/Insurance/GetFavorites`, method: 'GET'
    },
      options);
    }

export const getApiPatientPortalModMedUATGetModMedOrganizations = (

 options?: SecondParameter<typeof sendRequest<ModMedOrganizationDTO[]>>,) => {
      return sendRequest<ModMedOrganizationDTO[]>(
      {url: `/api/PatientPortal/ModMedUAT/GetModMedOrganizations`, method: 'GET'
    },
      options);
    }

export const postApiPatientPortalModMedUATGetAppointmentsForPatientByDate = (
    modMedUATAppointmentsRequestDTO: ModMedUATAppointmentsRequestDTO,
 options?: SecondParameter<typeof sendRequest<ModMedUATAppointmentDTO[]>>,) => {
      return sendRequest<ModMedUATAppointmentDTO[]>(
      {url: `/api/PatientPortal/ModMedUAT/GetAppointmentsForPatientByDate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modMedUATAppointmentsRequestDTO
    },
      options);
    }

export const postApiPatientPortalModMedUATCallForAppointmentReminder = (
    modMedUATSendCallRequestDTO: ModMedUATSendCallRequestDTO,
 options?: SecondParameter<typeof sendRequest<ModMedUATSendCallResponseDTO>>,) => {
      return sendRequest<ModMedUATSendCallResponseDTO>(
      {url: `/api/PatientPortal/ModMedUAT/CallForAppointmentReminder`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modMedUATSendCallRequestDTO
    },
      options);
    }

export const postApiPatientPortalModMedUATSendTempoDayOneCommunique = (
    modMedTempoSendCommuniqueRequestDTO: ModMedTempoSendCommuniqueRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PatientPortal/ModMedUAT/SendTempoDayOneCommunique`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modMedTempoSendCommuniqueRequestDTO
    },
      options);
    }

export const postApiPatientPortalModMedUATSendTempoDayTwoCommunique = (
    modMedTempoSendCommuniqueRequestDTO: ModMedTempoSendCommuniqueRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/PatientPortal/ModMedUAT/SendTempoDayTwoCommunique`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modMedTempoSendCommuniqueRequestDTO
    },
      options);
    }

export const postApiPatientPortalMultiMediaGetMultimedia = (
    patientPortalMultimediaRequestDTO: PatientPortalMultimediaRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/PatientPortal/MultiMedia/GetMultimedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPortalMultimediaRequestDTO
    },
      options);
    }

export const getApiPatientPortalMultiMediaGetMultiMediaById = (
    params?: GetApiPatientPortalMultiMediaGetMultiMediaByIdParams,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/PatientPortal/MultiMedia/GetMultiMediaById`, method: 'GET',
        params
    },
      options);
    }

export const postApiPatientPortalMultiMediaRequestMultiMedia = (
    multiMediaRequestDTO: MultiMediaRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/PatientPortal/MultiMedia/RequestMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: multiMediaRequestDTO
    },
      options);
    }

export const postApiPatientPortalMultiMediaUploadMultimedia = (
    patientPortalMultiMediaUploadDTO: PatientPortalMultiMediaUploadDTO,
 options?: SecondParameter<typeof sendRequest<PatientMultiMediaResponseDTO>>,) => {
      return sendRequest<PatientMultiMediaResponseDTO>(
      {url: `/api/PatientPortal/MultiMedia/UploadMultimedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPortalMultiMediaUploadDTO
    },
      options);
    }

export const getApiPatientPortalOrganizationGetOrgMapping = (

 options?: SecondParameter<typeof sendRequest<PatientOrgMappingDTO>>,) => {
      return sendRequest<PatientOrgMappingDTO>(
      {url: `/api/PatientPortal/Organization/GetOrgMapping`, method: 'GET'
    },
      options);
    }

export const getApiPatientPortalOrganizationGetOrgServiceFacilities = (
    params?: GetApiPatientPortalOrganizationGetOrgServiceFacilitiesParams,
 options?: SecondParameter<typeof sendRequest<ServiceFacilityDTOListDTO>>,) => {
      return sendRequest<ServiceFacilityDTOListDTO>(
      {url: `/api/PatientPortal/Organization/GetOrgServiceFacilities`, method: 'GET',
        params
    },
      options);
    }

export const getApiPatientPortalOrganizationGetOrg = (

 options?: SecondParameter<typeof sendRequest<OrganizationDTO>>,) => {
      return sendRequest<OrganizationDTO>(
      {url: `/api/PatientPortal/Organization/GetOrg`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetPCCItemsByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<PatientPCCItemsDTO>>,) => {
      return sendRequest<PatientPCCItemsDTO>(
      {url: `/api/Patient/GetPCCItemsByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetUnassociatedInsuranceCardsPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Patient/GetUnassociatedInsuranceCards/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiPatientGetInsuranceAttachmentsInsuranceId = (
    insuranceId: number,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO[]>>,) => {
      return sendRequest<InsuranceAttachmentDTO[]>(
      {url: `/api/Patient/GetInsuranceAttachments/${insuranceId}`, method: 'GET'
    },
      options);
    }

export const postApiPatientUploadAndAssociateInsuranceCardWithInsurance = (
    uploadAndAssociateInsuranceCardRequestDTO: UploadAndAssociateInsuranceCardRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO>>,) => {
      return sendRequest<InsuranceAttachmentDTO>(
      {url: `/api/Patient/UploadAndAssociateInsuranceCardWithInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadAndAssociateInsuranceCardRequestDTO
    },
      options);
    }

export const postApiPatientAssociateInsuranceCardWithInsurance = (
    associateInsuranceCardRequestDTO: AssociateInsuranceCardRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO>>,) => {
      return sendRequest<InsuranceAttachmentDTO>(
      {url: `/api/Patient/AssociateInsuranceCardWithInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateInsuranceCardRequestDTO
    },
      options);
    }

export const postApiPatientSyncInsuranceAttachments = (
    syncInsuranceAttachmentsRequestDTO: SyncInsuranceAttachmentsRequestDTO,
 options?: SecondParameter<typeof sendRequest<InsuranceAttachmentDTO[]>>,) => {
      return sendRequest<InsuranceAttachmentDTO[]>(
      {url: `/api/Patient/SyncInsuranceAttachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncInsuranceAttachmentsRequestDTO
    },
      options);
    }

export const getApiPCCConsentGetEnabledPrograms = (

 options?: SecondParameter<typeof sendRequest<PCCProgram[]>>,) => {
      return sendRequest<PCCProgram[]>(
      {url: `/api/PCCConsent/GetEnabledPrograms`, method: 'GET'
    },
      options);
    }

export const getApiPatientPortalProviderSearchExternalProvider = (
    params?: GetApiPatientPortalProviderSearchExternalProviderParams,
 options?: SecondParameter<typeof sendRequest<NPISearchResponseDTO>>,) => {
      return sendRequest<NPISearchResponseDTO>(
      {url: `/api/PatientPortal/Provider/SearchExternalProvider`, method: 'GET',
        params
    },
      options);
    }

export const getApiRTMGetStatusByPatientId = (
    params?: GetApiRTMGetStatusByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<RTMPatientStatusResponseDTO>>,) => {
      return sendRequest<RTMPatientStatusResponseDTO>(
      {url: `/api/RTM/GetStatusByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const getApiRTMGetEnrollmentInfo = (
    params?: GetApiRTMGetEnrollmentInfoParams,
 options?: SecondParameter<typeof sendRequest<RTMEnrollmentInfoResponse>>,) => {
      return sendRequest<RTMEnrollmentInfoResponse>(
      {url: `/api/RTM/GetEnrollmentInfo`, method: 'GET',
        params
    },
      options);
    }

export const postApiRTMCompleteEnrollment = (
    params?: PostApiRTMCompleteEnrollmentParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/RTM/CompleteEnrollment`, method: 'POST',
        params
    },
      options);
    }

export const getApiRTMGetCheckInQuestions = (
    params?: GetApiRTMGetCheckInQuestionsParams,
 options?: SecondParameter<typeof sendRequest<RTMQuestionsResponse>>,) => {
      return sendRequest<RTMQuestionsResponse>(
      {url: `/api/RTM/GetCheckInQuestions`, method: 'GET',
        params
    },
      options);
    }

export const postApiRTMSubmitCheckInAnswers = (
    rTMAnswers: RTMAnswers,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/RTM/SubmitCheckInAnswers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rTMAnswers
    },
      options);
    }

export const getApiSettingsGePatientHistoryOptions = (
    params?: GetApiSettingsGePatientHistoryOptionsParams,
 options?: SecondParameter<typeof sendRequest<StringPaginatedResponseDTO>>,) => {
      return sendRequest<StringPaginatedResponseDTO>(
      {url: `/api/Settings/GePatientHistoryOptions`, method: 'GET',
        params
    },
      options);
    }

export const getApiSettingsGetInsuranceSettings = (

 options?: SecondParameter<typeof sendRequest<InsuranceSettingsDTO>>,) => {
      return sendRequest<InsuranceSettingsDTO>(
      {url: `/api/Settings/GetInsuranceSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetAppointmentSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetAppointmentSettings`, method: 'GET'
    },
      options);
    }

export const getApiTempoGetTempoStatusByPatientId = (
    params?: GetApiTempoGetTempoStatusByPatientIdParams,
 options?: SecondParameter<typeof sendRequest<PatientTempoStatus>>,) => {
      return sendRequest<PatientTempoStatus>(
      {url: `/api/Tempo/GetTempoStatusByPatientId`, method: 'GET',
        params
    },
      options);
    }

export const postApiTempoSendDayOneCommunique = (
    params?: PostApiTempoSendDayOneCommuniqueParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Tempo/SendDayOneCommunique`, method: 'POST',
        params
    },
      options);
    }

export const postApiTempoSendDayTwoCommunique = (
    params?: PostApiTempoSendDayTwoCommuniqueParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/Tempo/SendDayTwoCommunique`, method: 'POST',
        params
    },
      options);
    }

export const getApiTempoTokenGetQuestions = (
    token: string,
 options?: SecondParameter<typeof sendRequest<TempoQuestionsResponse>>,) => {
      return sendRequest<TempoQuestionsResponse>(
      {url: `/api/Tempo/${token}/GetQuestions`, method: 'GET'
    },
      options);
    }

export const postApiTempoTokenSubmitAnswers = (
    token: string,
    tempoAnswers: TempoAnswers,
 options?: SecondParameter<typeof sendRequest<TempoSubmitAnswerResponseDto>>,) => {
      return sendRequest<TempoSubmitAnswerResponseDto>(
      {url: `/api/Tempo/${token}/SubmitAnswers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tempoAnswers
    },
      options);
    }

export type GetApiAddressGetGeoCodeByAddressResult = NonNullable<Awaited<ReturnType<typeof getApiAddressGetGeoCodeByAddress>>>
export type GetApiPatientPortalAppointmentUpcomingResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalAppointmentUpcoming>>>
export type GetApiPatientPortalAppointmentHistoricalResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalAppointmentHistorical>>>
export type PostApiPatientPortalAppointmentUpdateStatusResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAppointmentUpdateStatus>>>
export type GetApiPatientPortalAuthGetLoginOptionsResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalAuthGetLoginOptions>>>
export type PostApiPatientPortalAuthSendOTPResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthSendOTP>>>
export type PostApiPatientPortalAuthVerifyOTPResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthVerifyOTP>>>
export type PostApiPatientPortalAuthSendMagicLinkResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthSendMagicLink>>>
export type PostApiPatientPortalAuthSendOTPTestEmailResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthSendOTPTestEmail>>>
export type PostApiPatientPortalAuthSendMagicLinkTestEmailResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthSendMagicLinkTestEmail>>>
export type PostApiPatientPortalAuthApproveLoginResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthApproveLogin>>>
export type PostApiPatientPortalAuthCheckPasswordlessStatusResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthCheckPasswordlessStatus>>>
export type PostApiPatientPortalAuthGetTokenResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthGetToken>>>
export type PostApiPatientPortalAuthRefreshTokenResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthRefreshToken>>>
export type PostApiPatientPortalAuthLogoutResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalAuthLogout>>>
export type GetApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogIdResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogId>>>
export type GetApiPatientPortalBillingGetPaymentDetailsResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalBillingGetPaymentDetails>>>
export type PostApiPatientPortalBillingGenerateStatementForPatientPaymentResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalBillingGenerateStatementForPatientPayment>>>
export type GetApiPatientPortalBillingGetPatientStatementsResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalBillingGetPatientStatements>>>
export type GetApiPatientPortalChartsGetResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalChartsGet>>>
export type PatchApiPatientPortalChartsUpdateResult = NonNullable<Awaited<ReturnType<typeof patchApiPatientPortalChartsUpdate>>>
export type PostApiPatientPortalChartsAddInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalChartsAddInsurance>>>
export type PutApiPatientPortalChartsUpdateInsuranceResult = NonNullable<Awaited<ReturnType<typeof putApiPatientPortalChartsUpdateInsurance>>>
export type DeleteApiPatientPortalChartsDeleteInsuranceResult = NonNullable<Awaited<ReturnType<typeof deleteApiPatientPortalChartsDeleteInsurance>>>
export type GetApiCommunicationGetConsentFormCommuniqueByTokenTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetConsentFormCommuniqueByTokenToken>>>
export type GetApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssigneeResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssignee>>>
export type PostApiFormWorkflowCompletePatientStepResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowCompletePatientStep>>>
export type GetApiFormWorkflowGetWorkflowPdfsFormWorkflowIdResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetWorkflowPdfsFormWorkflowId>>>
export type GetApiPatientPortalInsuranceSearchResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalInsuranceSearch>>>
export type GetApiPatientPortalInsuranceGetFavoritesResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalInsuranceGetFavorites>>>
export type GetApiPatientPortalModMedUATGetModMedOrganizationsResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalModMedUATGetModMedOrganizations>>>
export type PostApiPatientPortalModMedUATGetAppointmentsForPatientByDateResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalModMedUATGetAppointmentsForPatientByDate>>>
export type PostApiPatientPortalModMedUATCallForAppointmentReminderResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalModMedUATCallForAppointmentReminder>>>
export type PostApiPatientPortalModMedUATSendTempoDayOneCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalModMedUATSendTempoDayOneCommunique>>>
export type PostApiPatientPortalModMedUATSendTempoDayTwoCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalModMedUATSendTempoDayTwoCommunique>>>
export type PostApiPatientPortalMultiMediaGetMultimediaResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalMultiMediaGetMultimedia>>>
export type GetApiPatientPortalMultiMediaGetMultiMediaByIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalMultiMediaGetMultiMediaById>>>
export type PostApiPatientPortalMultiMediaRequestMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalMultiMediaRequestMultiMedia>>>
export type PostApiPatientPortalMultiMediaUploadMultimediaResult = NonNullable<Awaited<ReturnType<typeof postApiPatientPortalMultiMediaUploadMultimedia>>>
export type GetApiPatientPortalOrganizationGetOrgMappingResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalOrganizationGetOrgMapping>>>
export type GetApiPatientPortalOrganizationGetOrgServiceFacilitiesResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalOrganizationGetOrgServiceFacilities>>>
export type GetApiPatientPortalOrganizationGetOrgResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalOrganizationGetOrg>>>
export type GetApiPatientGetPCCItemsByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPCCItemsByPatientIdPatientId>>>
export type GetApiPatientGetUnassociatedInsuranceCardsPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetUnassociatedInsuranceCardsPatientId>>>
export type GetApiPatientGetInsuranceAttachmentsInsuranceIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetInsuranceAttachmentsInsuranceId>>>
export type PostApiPatientUploadAndAssociateInsuranceCardWithInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientUploadAndAssociateInsuranceCardWithInsurance>>>
export type PostApiPatientAssociateInsuranceCardWithInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAssociateInsuranceCardWithInsurance>>>
export type PostApiPatientSyncInsuranceAttachmentsResult = NonNullable<Awaited<ReturnType<typeof postApiPatientSyncInsuranceAttachments>>>
export type GetApiPCCConsentGetEnabledProgramsResult = NonNullable<Awaited<ReturnType<typeof getApiPCCConsentGetEnabledPrograms>>>
export type GetApiPatientPortalProviderSearchExternalProviderResult = NonNullable<Awaited<ReturnType<typeof getApiPatientPortalProviderSearchExternalProvider>>>
export type GetApiRTMGetStatusByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiRTMGetStatusByPatientId>>>
export type GetApiRTMGetEnrollmentInfoResult = NonNullable<Awaited<ReturnType<typeof getApiRTMGetEnrollmentInfo>>>
export type PostApiRTMCompleteEnrollmentResult = NonNullable<Awaited<ReturnType<typeof postApiRTMCompleteEnrollment>>>
export type GetApiRTMGetCheckInQuestionsResult = NonNullable<Awaited<ReturnType<typeof getApiRTMGetCheckInQuestions>>>
export type PostApiRTMSubmitCheckInAnswersResult = NonNullable<Awaited<ReturnType<typeof postApiRTMSubmitCheckInAnswers>>>
export type GetApiSettingsGePatientHistoryOptionsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGePatientHistoryOptions>>>
export type GetApiSettingsGetInsuranceSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetInsuranceSettings>>>
export type GetApiSettingsGetAppointmentSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetAppointmentSettings>>>
export type GetApiTempoGetTempoStatusByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiTempoGetTempoStatusByPatientId>>>
export type PostApiTempoSendDayOneCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiTempoSendDayOneCommunique>>>
export type PostApiTempoSendDayTwoCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiTempoSendDayTwoCommunique>>>
export type GetApiTempoTokenGetQuestionsResult = NonNullable<Awaited<ReturnType<typeof getApiTempoTokenGetQuestions>>>
export type PostApiTempoTokenSubmitAnswersResult = NonNullable<Awaited<ReturnType<typeof postApiTempoTokenSubmitAnswers>>>
